import Backbone from 'backbone'
import _ from 'lodash'

var Group = Backbone.Model.extend({

	domainType: 'group',

	defaults: {
		'orgPermissions': []
	},

	urlRoot: function(options) {
		return 'api/admin/groups'
	},

	/**
	 * @returns {Object} a mapping of orgId: data
	 * @example [{orgId: {id: 124, label: "Org Label", projectId: 51, descendants: 1, cascade: true, order: 1}}]
	 */
	getOrgPermissions() {
		const orgList = this.get('orgPermissions')
		return _.keyBy(orgList, 'id')
	},

	setOrgPermissions(permissions) {
		this.set('orgPermissions', permissions)
	}
})

export default Group

Group.__filename__ = 'admin/principals/groups/group.js'
